import { render, staticRenderFns } from "./PartialAccess.vue?vue&type=template&id=3b3ea170&scoped=true&"
import script from "./PartialAccess.vue?vue&type=script&lang=js&"
export * from "./PartialAccess.vue?vue&type=script&lang=js&"
import style0 from "./PartialAccess.vue?vue&type=style&index=0&id=3b3ea170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ea170",
  null
  
)

export default component.exports